import { api, get, post, del } from './client.js';

export const callsApi = {
    list: (hostId, params = {}) => {
        const qs = new URLSearchParams({ hostId, ...params }).toString();
        return get(`/api/ivr/calls/list?${qs}`);
    },
    get: (hostId, id) =>
        get(`/api/ivr/calls/${encodeURIComponent(id)}?hostId=${encodeURIComponent(hostId)}`),
    setTags: (hostId, id, tagIds) =>
        api(
            'PATCH',
            `/api/ivr/calls/${encodeURIComponent(id)}/tags?hostId=${encodeURIComponent(hostId)}`,
            { body: { tagIds } }
        ),
    remove: (hostId, id) =>
        del(`/api/ivr/calls/${encodeURIComponent(id)}?hostId=${encodeURIComponent(hostId)}`),
    // xlsx 匯出（每日彙總 + 通話明細）；params: direction/wasAnswered/fromMillis/toMillis/source/phone/lang
    exportUrl: (hostId, params = {}) => {
        const qs = new URLSearchParams({ hostId });
        for (const [k, v] of Object.entries(params)) {
            if (v !== undefined && v !== null && v !== '') qs.set(k, v);
        }
        return `/api/ivr/calls/export.xlsx?${qs.toString()}`;
    },
};

export const directoryApi = {
    // includeDisabled=1：管理頁要看得到「停用」的人（否則停用=從列表消失，像被刪除）＋不吃 cache（開關即時反映）
    list: (hostId) => get(`/api/ivr/directory/list?hostId=${encodeURIComponent(hostId)}&includeDisabled=1`),
    upsert: (body) => post('/api/ivr/directory/', body),
    remove: (id, hostId) =>
        del(`/api/ivr/directory/${encodeURIComponent(id)}?hostId=${encodeURIComponent(hostId)}`),
    clearAll: (hostId) => post('/api/ivr/directory/clear', { hostId }),

    // 匯入相關 — 走 ivr-builder-api（claude CLI + import-directory skill）
    importStart: async (hostId, file) => {
        const fd = new FormData();
        fd.append('hostId', hostId);
        fd.append('file', file);
        return api('POST', '/ivr-builder/api/directory-import/start', { body: fd });
    },
    importStatus: (jobId) =>
        get(`/ivr-builder/api/directory-import/jobs/${encodeURIComponent(jobId)}`),
    importList: (hostId) =>
        get(`/ivr-builder/api/directory-import/jobs?hostId=${encodeURIComponent(hostId)}`),
    importConfirm: (jobId, contacts, dedupeBy = 'ext') =>
        post(`/ivr-builder/api/directory-import/jobs/${encodeURIComponent(jobId)}/confirm`, { contacts, dedupeBy }),
    importDismiss: (jobId) =>
        del(`/ivr-builder/api/directory-import/jobs/${encodeURIComponent(jobId)}`),
};

export const customersApi = {
    list: (hostId, params = {}) => {
        const qs = new URLSearchParams({ hostId, ...params }).toString();
        return get(`/api/ivr/customers/list?${qs}`);
    },
    timeline: (hostId, phone, params = {}) => {
        const qs = new URLSearchParams({ hostId, ...params }).toString();
        return get(`/api/ivr/customers/${encodeURIComponent(phone)}?${qs}`);
    },
};

export const tagsApi = {
    list: (hostId) => get(`/api/ivr/tags?hostId=${encodeURIComponent(hostId)}`),
    upsert: (body) => post('/api/ivr/tags', body),
    remove: (id, hostId) =>
        del(`/api/ivr/tags/${encodeURIComponent(id)}?hostId=${encodeURIComponent(hostId)}`),
};
